function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_23",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 23",
  transform: "translate(0.501 0.5)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Icon_open-cart",
  "data-name": "Icon open-cart",
  d: "M-.361,2.319A2.025,2.025,0,0,0,1.958,4h6l.36,1,1.64,5,1.64,5a1.621,1.621,0,0,0,1.36,1h14a1.571,1.571,0,0,0,1.36-1l3.24-10c.16-.52-.08-1-.64-1H13.158l-1.52-2.88A2,2,0,0,0,9.878,0h-8a2,2,0,0,0-.36,0C1.439-.006-.538,1.214-.361,2.319Z",
  transform: "translate(0.373 0.009)",
  fill: "none",
  stroke: "#313136",
  strokeWidth: 1
}), /*#__PURE__*/React.createElement("g", {
  id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_8",
  "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 8",
  transform: "translate(13.319 19.554)",
  fill: "none",
  stroke: "#313136",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.222,
  cy: 2.222,
  r: 2.222,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.222,
  cy: 2.222,
  r: 1.722,
  fill: "none"
})), /*#__PURE__*/React.createElement("g", {
  id: "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441_9",
  "data-name": "\\u042D\\u043B\\u043B\\u0438\\u043F\\u0441 9",
  transform: "translate(23.096 19.554)",
  fill: "none",
  stroke: "#313136",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("circle", {
  cx: 2.222,
  cy: 2.222,
  r: 2.222,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.222,
  cy: 2.222,
  r: 1.722,
  fill: "none"
})));

var SvgCart20 = function SvgCart20(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.982,
    height: 24.498,
    viewBox: "0 0 32.982 24.498",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCart20, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cart-20.2974da9d.svg";
export { ForwardRef as ReactComponent };